import { Template } from './templates/Template';
import { ErrorBoundary } from 'react-error-boundary';
import ErrorPage from './modules/error/ErrorPage';
import { clearLocalStorage } from './utils/utils';
import 'react-toastify/dist/ReactToastify.css';
import ContextProviders from './context/ContextProviders';
import { HelmetProvider } from 'react-helmet-async';
import Toaster from './components/common/Toaster';
import ThemeWrapper from './components/common/ThemeWrapper';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { setNavigator } from './utils/navigation';

const AppContent = () => {
  const navigate = useNavigate();

  useEffect(() => {
    setNavigator(navigate);
  }, [navigate]);

  return (
    <ContextProviders>
      <Toaster />
      <HelmetProvider>
        <Template />
      </HelmetProvider>
    </ContextProviders>
  );
};

function App() {
  return (
    <ThemeWrapper>
      <ErrorBoundary
        FallbackComponent={ErrorPage}
        onReset={() => {
          clearLocalStorage();
        }}
      >
        <AppContent />
      </ErrorBoundary>
    </ThemeWrapper>
  );
}

export default App;
